import React from 'react';
import { ChevronRight } from 'lucide-react';
import { WavyBackground } from './ui/wavy-background';
import { Button } from './ui/neon-button';
import { useTranslation } from 'react-i18next';

const Hero = () => {
  const { t } = useTranslation();

  const scrollToProducts = () => {
    const productsSection = document.getElementById('products');
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <WavyBackground 
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 min-h-[calc(100vh-4rem)] flex items-center"
      colors={[
        "#1E3A8A", // Deep blue
        "#2563EB", // Lighter blue
        "#3B82F6", // Sky blue
        "#1E40AF", // Royal blue
        "#1E3A8A", // Deep blue again
      ]}
      waveWidth={50}
      backgroundFill="#111827"
      blur={10}
      speed="slow"
      waveOpacity={0.3}
    >
      <div className="max-w-xl w-full pt-16 md:pt-20 lg:pt-24">
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
          {t('hero.title')}
        </h2>
        <p className="text-base sm:text-lg text-gray-200 mb-6 sm:mb-8 leading-relaxed">
          {t('hero.description')}
        </p>
        <Button 
          variant="solid" 
          size="lg"
          onClick={scrollToProducts}
          className="inline-flex items-center text-base sm:text-lg transform hover:scale-105 transition-transform duration-200"
        >
          {t('hero.exploreButton')}
          <ChevronRight className="ml-2 h-5 w-5" />
        </Button>
      </div>
    </WavyBackground>
  );
};

export default Hero;